import {
  LayoutDashboard,
  MessageSquare,
  Sparkles,
  Target,
  Briefcase,
  PhoneCall,
  CalendarDays,
  Settings2,
  type LucideIcon,
} from 'lucide-react';

export type AISectionId =
  | 'overview'
  | 'assistant'
  | 'insights'
  | 'leads'
  | 'deals'
  | 'optimization'
  | 'meeting'
  | 'settings';

export interface AISectionDef {
  id: AISectionId;
  label: string;
  icon: LucideIcon;
  /** true = depends on the generative LLM provider (Layer 2). */
  generative: boolean;
  /** Hidden executive feature; presentation only, never a server authorization grant. */
  executiveOnly?: boolean;
}

export const AI_SECTIONS: AISectionDef[] = [
  { id: 'overview', label: 'Overview', icon: LayoutDashboard, generative: false },
  { id: 'assistant', label: 'Assistant', icon: MessageSquare, generative: true },
  { id: 'insights', label: 'Insights', icon: Sparkles, generative: false },
  { id: 'leads', label: 'Lead Intelligence', icon: Target, generative: false },
  { id: 'deals', label: 'Deal Intelligence', icon: Briefcase, generative: false },
  { id: 'optimization', label: 'Sales Optimization', icon: PhoneCall, generative: false },
  { id: 'meeting', label: 'Meeting Assistant', icon: CalendarDays, generative: true },
  {
    id: 'settings',
    label: 'AI Management',
    icon: Settings2,
    generative: false,
    executiveOnly: true,
  },
];

/**
 * Honest system-state copy for the generative layer. These are UI status
 * messages (NOT fabricated AI output) shown when the backend LLM provider is
 * unavailable or not configured.
 */
export const GENERATIVE_UNAVAILABLE_TITLE = 'Generative AI is currently unavailable';
export const GENERATIVE_UNAVAILABLE_BODY =
  'This is a real capability connected to a live backend endpoint. It will activate automatically after an administrator enables Zynx AI Gateway (LiteLLM) in Settings > Integrations.';
export const GENERATIVE_ERROR_TITLE = 'Could not reach the AI service';
export const GENERATIVE_ERROR_BODY = 'There was a network problem contacting the AI endpoint. Please try again.';
